import { CheckCircle } from 'lucide-react';
import * as React from 'react';

export function SubmissionConfirmation () {
    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-space-y-6 tw-my-12">
            <CheckCircle className="tw-text-primary" size={48}/>
            <div className="tw-space-y-2">
                <h2 className="tw-text-xl tw-font-semibold">
                    {i18next.t('signup.thank_you_for_applying')}
                </h2>
                <p className="tw-text-muted-foreground tw-max-w-md">
                    {i18next.t('signup.application_received_message')}
                </p>
            </div>
        </div>
    );
}
